import { MAS } from "@bluframe/mightychroma-mightytool-frontend-types"
import { memo } from "react"

import Details from "./Details"

interface Props extends MAS {}

export interface ComponentProps extends Props {}

export default memo<Props>(Details)
